// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsie-takeaway-points-editor-container {
  flex: 1 1;
  flex-direction: column;
  background-color: rgba(112, 128, 144, 0.171);
  display: flex;
  gap: 5px;
  height: 100%;
  padding: 5px;
  border-radius: 2px;
  overflow-y: scroll;
}

.newsie-takeaway-points-editor-button-row-container {
  display: flex;
  justify-content: flex-end;
}

.newsie-takeaway-points-editor-button{
  background-color: rgba(95, 158, 160, 0.315);
  padding: 5px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Games/Newsie/NewsieTakeawayPointsEditor/NewsieTakeawayPointEditor.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,sBAAsB;EACtB,4CAA4C;EAC5C,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".newsie-takeaway-points-editor-container {\n  flex: 1;\n  flex-direction: column;\n  background-color: rgba(112, 128, 144, 0.171);\n  display: flex;\n  gap: 5px;\n  height: 100%;\n  padding: 5px;\n  border-radius: 2px;\n  overflow-y: scroll;\n}\n\n.newsie-takeaway-points-editor-button-row-container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.newsie-takeaway-points-editor-button{\n  background-color: rgba(95, 158, 160, 0.315);\n  padding: 5px;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
